import { createBlacklistFilter } from 'redux-persist-transform-filter';

// persistence config
export const sellingCompaniesBlacklistFilter = createBlacklistFilter(
  'sellingCompanies',
  ['loading', 'error']
);
